let navigate = null;

export const setNavigate = (navFn) => {
  navigate = navFn;
};

export const redirectToLanding = () => {
  if (navigate) {
    navigate("/landing");
  } else {
    window.location.href = "/landing"; // fallback
  }
};
